interface Properties {
  onClick?: () => void;
}

const SubmitButton: React.FC<Properties> = ({ ...props }) => {
  return (
    <button
      className="bg-blue-400 w-full p-4 rounded-lg font-bold text-white text-lg"
      {...props}
    />
  );
};

export default SubmitButton;
